import axios from 'axios'
import { useAuth } from '@/composables/use-auth'

export const api = axios.create({
  baseURL: import.meta.env.VITE_API_URL,
})

api.interceptors.request.use(
  (config) => {
    const { accessToken } = useAuth()

    config.headers['Authorization'] = `Bearer ${accessToken.value}`

    return config
  },
  (error) => {
    return Promise.reject(error)
  },
)
